import { connect } from 'react-redux';
import Facts from './Facts';
import { getHotelFacts } from '../../store/hotel';

const mapStateToProps = (state) => ({
  facts: getHotelFacts(state),
});

export default connect(mapStateToProps)(Facts);
